export default "__VITE_ASSET__913afdaa__"